/**
 * When the way back to the top is worth offering.
 *
 * The status-bar tap was meant to be this and never fired: measured on shell 348, UIKit only offers
 * that gesture to a scroll view with somewhere to go, and the page scrolls inside an element of its
 * own. A button in the page needs no gesture, and works in Safari where the tap never could.
 */

/** Far enough down that thumbing back is a chore, and far enough that the button is not underfoot. */
const SHOW_AFTER_SCREENS = 1.5;

/**
 * Hidden slightly later than it is shown, so a scroll resting on the threshold cannot flicker the
 * button in and out on every frame.
 */
const HIDE_AFTER_SCREENS = 1.25;

export function showsScrollTop(scrollTop: number, viewportHeight: number, showing = false): boolean {
	if (viewportHeight <= 0) {
		return false;
	}
	return scrollTop > viewportHeight * (showing ? HIDE_AFTER_SCREENS : SHOW_AFTER_SCREENS);
}
